import Api from 'entities/helpers/api';

export const saveUserWidgets = (user_id, data) => {
  return Api.HUB.WIDGET_USER_SETTINGS.post({
    params: { solicitor_user_id: user_id },
    data: JSON.stringify(data),
  });
};
